function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 35,
  cy: 35,
  r: 35,
  fill: "#0DBD7F",
  fillOpacity: 0.07
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M30.5 35a6 6 0 1 0 0-12 6 6 0 1 0 0 12Zm4.2 1.5h-.783a8.169 8.169 0 0 1-6.834 0H26.3a6.302 6.302 0 0 0-6.3 6.3v1.95A2.25 2.25 0 0 0 22.25 47h16.5A2.25 2.25 0 0 0 41 44.75V42.8c0-3.478-2.822-6.3-6.3-6.3Zm15.14-6.019-1.303-1.317a.556.556 0 0 0-.787-.005l-4.913 4.875-2.132-2.146a.556.556 0 0 0-.788-.005L38.6 33.19a.556.556 0 0 0-.005.787l3.83 3.858c.216.22.567.22.788.005l6.623-6.572a.56.56 0 0 0 .005-.788Z",
  fill: "#0DBD7F"
}));

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(20 23)",
  d: "M0 0h30v24H0z"
})));

function SvgIcPenggunaOnline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPenggunaOnline);
export default __webpack_public_path__ + "static/media/ic_pengguna_online.87f0f63e.svg";
export { ForwardRef as ReactComponent };